export interface DashboardState {
    totalBalance: any;
}

export const initialState = {
    totalBalance: {}
}